export const ITEM_LABELS = [
    { value: 'RED', color: '#d70000', i18nKey: 'labelMenu.red' },
    { value: 'ORANGE', color: '#fb923c', i18nKey: 'labelMenu.orange' },
    { value: 'YELLOW', color: '#facc15', i18nKey: 'labelMenu.yellow' },
    { value: 'GREEN', color: '#1B5E20', i18nKey: 'labelMenu.green' },
    { value: 'BLUE', color: '#0c0eff', i18nKey: 'labelMenu.blue' },
    { value: 'PURPLE', color: '#A020F0', i18nKey: 'labelMenu.purple' },
];

export const getItemLabelColor = (label) =>
    ITEM_LABELS.find((item) => item.value === label)?.color || null;
